import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import Header from "./Header/index.jsx";
import Footer from "./Footer/index.jsx";
import Sidebar from "./Sidebar/index.jsx";
import DashboardSidebar from "./DashboardSidebar/index.jsx";
import BottomNav from "./BottomNav/index.js";
import {
  LoadingComponent,
  ToastNotify,
  SpinnerComponent,
} from "interface/components";

import dashboardRoutes from "../nav";

const WebLayout = () => {
  const { General } = useSelector((state) => state);
  const { ShowUC, isLoaded } = General || {};

  const [allDone, setAllDone] = useState(false);

  useEffect(() => {
    // Chỉ nạp router khi General và ShowUC đã được tải xong từ CSDL
    if (isLoaded || ShowUC !== undefined) {
      setAllDone(true);
    }
  }, [General, isLoaded, ShowUC]);

  const switchRoutes = () => {
    return (
      <Routes>
        {dashboardRoutes.map((prop, key) =>
          (prop.isUpdating && !ShowUC) ? null : (
            <Route
              path={prop.path}
              element={
                prop.redirect ? (
                  <Navigate from={prop.path} to={prop.to} key={key} />
                ) : (
                  <React.Suspense fallback={<LoadingComponent />}>
                    {prop.component}
                  </React.Suspense>
                )
              }
              key={key}
            />
          ),
        )}
      </Routes>
    );
  };

  if (!allDone) {
    return <LoadingComponent />;
  }

  const divStyle = {
    backgroundImage: `url(${require("common/assets/imgs/BG.png")})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <React.Fragment>
      <div className="application" style={divStyle}>
        <div className="application-container-web">
          <Header />
          {/* <Sidebar /> */}
          <div className="dashboard-shell ds-desktop-shell">
            <DashboardSidebar />
            <main
              className="main-layout ds-main-content"
              style={{ backgroundColor: "transparent" }}
            >
              <div
                className="container-fluid main-layout-container"
                style={{ backgroundColor: "transparent" }}
              >
                {switchRoutes()}
                <SpinnerComponent />
              </div>
            </main>
          </div>
          {/* <Footer /> */}
        </div>
      </div>
      <ToastNotify />
      <BottomNav />
    </React.Fragment>
  );
};

export default WebLayout;
